import { FeatureWithBenefitsProps } from "@bluebottlecoffee/design-system/components";
import { FeatureWithBenefits as Schema } from "../sanity-schema";
import { toImageProps } from "./image";
import { toLinkProps } from "./link";

export function toFeatureWithBenefitsProps(
  data: Schema,
  region: string,
  lang: string,
): FeatureWithBenefitsProps {
  return {
    badgeImages: data.badgeImages.map((image) => toImageProps(image, lang)),
    badgeText: data.badgeText[lang],
    heading: data.heading[lang],
    subheading: data.subheading[lang],
    benefits: data.benefits.map((benefit) => {
      if ("label" in benefit && benefit.label) {
        return {
          label: benefit.label[lang],
          ...(benefit.icon && { icon: toImageProps(benefit.icon, lang) }),
        };
      }

      return (benefit as unknown as Record<string, string>)[lang];
    }),
    primaryCta: toLinkProps(data.primaryCta, region, lang),
    secondaryCta: toLinkProps(data.secondaryCta, region, lang),
    image: toImageProps(data.image, lang),
  };
}
